<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-checkbox v-model="compra.notificaFornecedor"
                    color="primary">
          <template v-slot:label>
            <div class="text--primary">
              {{ checkBoxLabel }}
            </div>
          </template>
        </v-checkbox>
       </v-col>
      </v-row>
      <v-row dense v-if="compra.notificaFornecedor">
        <v-col cols="6">
          <v-textarea
            outlined
            rows="2"
            v-model="compra.mensagem"
            label="Mensagem para o fornecedor"
            counter="1500"
            class="rounded-tag-small"
          />
        </v-col>
    </v-row>
    <v-divider/>
    <v-row dense class="mt-3">
      <v-col cols="12" sm="11">
        <px-autocomplete-mensagem-personalizada
          class="rounded-tag-small"
          dense
          v-model="mensagemPersonalizada"
          :error="$v.mensagemPersonalizada.$error"
          @blur="$v.mensagemPersonalizada.$touch()"/>
      </v-col>
      <v-col cols="12" sm="1" align-self="center">
        <v-btn color="primary"
               x-small
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickAdd">
          <v-icon x-small>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col cols="12" v-if="checkMessages">
        <v-card outlined class="rounded-card">
          <px-mensagens-personalizadas-list
              show-actions
              :messages="compra.mensagensPersonalizadas"
              :loading="loading"
              @remove="onRemove"/>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-btn color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
            @click="enviar">
          Continuar
      </v-btn>
      <v-btn text link class="normal-btn-text" @click="previous">Voltar</v-btn>
    </v-row>
  </v-container>
</template>
<script>
import validationMixin from '@/mixins/validation-mixin';
import { required } from 'vuelidate/lib/validators';
import MessageService from '@/api/message-service';

export default {
  mixins: [validationMixin],
  props: {
    compra: {
      type: Object,
      required: true,
    },
    isEdicao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      mensagemPersonalizada: null,
    };
  },
  computed: {
    checkBoxLabel() {
      if (this.isEdicao) {
        return 'Notificar fornecedor da alteração da compra';
      }
      return 'Solicitar confirmação da compra e notificar fornecedor';
    },
    checkMessages() {
      return this.compra.mensagensPersonalizadas
        && this.compra.mensagensPersonalizadas.length
        && this.compra.mensagensPersonalizadas.length > 0;
    },
  },
  methods: {
    enviar() {
      this.$emit('ready', this.compra);
    },
    previous() {
      this.$emit('previous');
    },
    checkAlreadyAdded(id) {
      return this.compra.mensagensPersonalizadas.find(message => message.id === id);
    },
    onClickAdd() {
      if (this.validateForm()) {
        return;
      }
      if (this.checkAlreadyAdded(this.mensagemPersonalizada.id)) {
        this.$toast('Mensagem já adicionada', { color: 'error' });
        this.mensagemPersonalizada = null;
        return;
      }
      this.compra.mensagensPersonalizadas.push(this.mensagemPersonalizada);
      this.mensagemPersonalizada = null;
    },
    onRemove(item) {
      this.$emit('remove', item);
    },
    getMessagesPadrao() {
      this.loading = true;
      const params = {
        query: 'padrao is true',
      };
      MessageService.getMessages(params)
        .then((response) => {
          this.compra.mensagensPersonalizadas = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.compra.mensagensPersonalizadas.length === 0) {
      this.getMessagesPadrao();
    }
  },
  validations: {
    mensagemPersonalizada: {
      required,
    },
  },
};
</script>
